/**
 * Address validation / normalisation helpers — the TypeScript mirror of the
 * API's apps/api/src/address.py, so the forms validate & format addresses the
 * same way the backend stores them.
 *
 * Canonical postal code: "1234 AB" (4 digits, single space, 2 uppercase letters).
 */

/** True if the string is (or can be cleaned into) a valid NL postal code. */
export function isValidPostalCode(value: string): boolean {
	const raw = value.replace(/[\s.\-]/g, '').toUpperCase();
	return /^[1-9][0-9]{3}[A-Z]{2}$/.test(raw);
}

/** "1234ab" / "1234-ab" -> "1234 AB". Returns the trimmed input if not parseable. */
export function normalizePostalCode(value: string): string {
	const raw = value.replace(/[\s.\-]/g, '').toUpperCase();
	const m = raw.match(/^([1-9][0-9]{3})([A-Z]{2})$/);
	return m ? `${m[1]} ${m[2]}` : value.trim();
}

/** "12 a" -> "12A"; collapses whitespace. */
export function normalizeHouseNumber(value: string): string {
	const s = value.replace(/\s+/g, ' ').trim();
	const m = s.match(/^(\d+)\s*([A-Za-z])$/);
	return m ? `${m[1]}${m[2].toUpperCase()}` : s;
}

/** True if the house number starts with a digit. */
export function isValidHouseNumber(value: string): boolean {
	return /^\d/.test(value.trim());
}

/** Trim + collapse internal whitespace. */
export function cleanText(value: string): string {
	return value.replace(/\s+/g, ' ').trim();
}
